const BASE = process.env.REACT_APP_BACKEND_URL + '/api';

const getToken = () => localStorage.getItem('hygad_token');

const headers = (extra = {}) => ({
  'Content-Type': 'application/json',
  ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {}),
  ...extra
});

async function request(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, { headers: headers(), ...options });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || `Error ${res.status}`);
  return data;
}

// Auth
export const authAPI = {
  register: (d) => request('/auth/register', { method: 'POST', body: JSON.stringify(d) }),
  login: (d) => request('/auth/login', { method: 'POST', body: JSON.stringify(d) }),
  me: () => request('/auth/me')
};

// Properties
export const propertiesAPI = {
  search: (params = {}) => {
    const q = new URLSearchParams(Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== '' && v !== null)));
    return request(`/properties?${q}`);
  },
  getById: (id) => request(`/properties/${id}`),
};

// Enquiries
export const enquiriesAPI = {
  create: (d) => request('/enquiries', { method: 'POST', body: JSON.stringify(d) })
};

// Bookings
export const bookingsAPI = {
  checkAvailability: (propertyId, params) => {
    const q = new URLSearchParams(Object.fromEntries(Object.entries(params).filter(([,v]) => v)));
    return request(`/properties/${propertyId}/availability/check?${q}`);
  },
  getBlockedDates: (propertyId) => request(`/properties/${propertyId}/availability/blocked`),
  initiate: (d) => request('/bookings/initiate', { method: 'POST', body: JSON.stringify(d) }),
  confirm: (d) => request('/bookings/confirm', { method: 'POST', body: JSON.stringify(d) }),
  getById: (bookingId) => request(`/bookings/${bookingId}`),
  getCustomer: (status) => request(`/customer/bookings${status ? `?status=${status}` : ''}`),
  cancelCustomer: (bookingId) => request(`/customer/bookings/${bookingId}/cancel`, { method: 'PUT' }),
  getPartner: (status) => request(`/partner/bookings${status ? `?status=${status}` : ''}`),
  updateAvailability: (propertyId, blocked_dates) => request(`/partner/properties/${propertyId}/availability`, { method: 'PUT', body: JSON.stringify({ blocked_dates }) }),
};

// Locations
export const locationsAPI = {
  search: (q) => request(`/locations/search?q=${encodeURIComponent(q)}`),
  adminGet: () => request('/admin/locations'),
  adminCreate: (d) => request('/admin/locations', { method: 'POST', body: JSON.stringify(d) }),
  adminUpdate: (id, d) => request(`/admin/locations/${id}`, { method: 'PUT', body: JSON.stringify(d) }),
  adminDelete: (id) => request(`/admin/locations/${id}`, { method: 'DELETE' }),
};

// Partner - add bookings
export const partnerAPI = {
  getDashboard: () => request('/partner/dashboard'),
  getProperties: () => request('/partner/properties'),
  createProperty: (d) => request('/partner/properties', { method: 'POST', body: JSON.stringify(d) }),
  getEnquiries: () => request('/partner/enquiries'),
  getPayments: () => request('/partner/payments'),
};

// Payments
export const paymentsAPI = {
  getConfig: () => request('/payments/config'),
};

// Reviews
export const reviewsAPI = {
  getByProperty: (propertyId) => request(`/reviews/${propertyId}`),
  create: (d) => request('/reviews', { method: 'POST', body: JSON.stringify(d) }),
  getPartnerReviews: () => request('/partner/reviews'),
  addReply: (reviewId, reply) => request(`/partner/reviews/${reviewId}/reply`, { method: 'PUT', body: JSON.stringify({ reply }) }),
  deleteReply: (reviewId) => request(`/partner/reviews/${reviewId}/reply`, { method: 'DELETE' }),
};

// Admin
export const adminAPI = {
  getDashboard: () => request('/admin/dashboard'),
  getPartners: (status) => request(`/admin/partners${status ? `?status=${status}` : ''}`),
  updatePartner: (id, d) => request(`/admin/partners/${id}/status`, { method: 'PUT', body: JSON.stringify(d) }),
  getProperties: (status) => request(`/admin/properties${status ? `?status=${status}` : ''}`),
  updateProperty: (id, d) => request(`/admin/properties/${id}/status`, { method: 'PUT', body: JSON.stringify(d) }),
  getUsers: () => request('/admin/users'),
  getEnquiries: () => request('/admin/enquiries'),
  getPayments: () => request('/admin/payments'),
  getReviews: (status) => request(`/admin/reviews${status ? `?status=${status}` : ''}`),
  updateReview: (id, d) => request(`/admin/reviews/${id}/status`, { method: 'PUT', body: JSON.stringify(d) }),
  getBookings: (status) => request(`/admin/bookings${status ? `?status=${status}` : ''}`),
  updateBooking: (id, d) => request(`/admin/bookings/${id}/status`, { method: 'PUT', body: JSON.stringify(d) }),
  getLocations: () => request('/admin/locations'),
  seed: () => request('/admin/seed', { method: 'POST' }),
  seedLocations: () => request('/admin/seed-locations', { method: 'POST' })
};
